import { Navigate, useSearchParams } from 'react-router-dom';

const isIsoYmd = (value: string | null): boolean =>
  Boolean(value && /^\d{4}-\d{2}-\d{2}$/.test(value));

/** Redirect legacy /tasks?tab=… URLs to new sub-pages. */
export const TaskListLegacyRedirect = () => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');

  if (tab === 'edit') {
    const editSubTab = searchParams.get('editSubTab');
    const next = new URLSearchParams();
    if (editSubTab === 'effective' || editSubTab === 'expired' || editSubTab === 'all') {
      next.set('editSubTab', editSubTab);
    }
    const qs = next.toString();
    return <Navigate to={qs ? `/tasks/edit-all?${qs}` : '/tasks/edit-all'} replace />;
  }

  if (tab === 'overdue') {
    return <Navigate to="/tasks/overdue" replace />;
  }

  if (tab === 'history') {
    const next = new URLSearchParams();
    const histStart = searchParams.get('histStart');
    const histEnd = searchParams.get('histEnd');
    const histStatus = searchParams.get('histStatus');
    const histScroll = searchParams.get('histScroll');
    if (isIsoYmd(histStart)) next.set('histStart', histStart!);
    if (isIsoYmd(histEnd)) next.set('histEnd', histEnd!);
    if (histStatus) next.set('histStatus', histStatus);
    if (histScroll) next.set('histScroll', histScroll);
    const qs = next.toString();
    return <Navigate to={qs ? `/tasks/history?${qs}` : '/tasks/history'} replace />;
  }

  if (tab === 'today') {
    const next = new URLSearchParams();
    const date = searchParams.get('date');
    if (isIsoYmd(date)) next.set('date', date!);
    const qs = next.toString();
    return <Navigate to={qs ? `/tasks?${qs}` : '/tasks'} replace />;
  }

  return null;
};
